// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vue-blockui/dist/vue-blockui.css
// module id = /rev
// module chunks = 1